import { deleteObject, ref, uploadBytes } from 'firebase/storage';

import { FSCollections } from '@src/constants/database';
import { storage } from '@src/firebase/firebase';
import { generateFirestoreId } from '@src/util/firestore/generateFirestoreId';

export interface WorkOrderPhotoUploadParams {
  organizationId: string;
  divisionId: string;
  file: File;
  kind?: 'photo' | 'signature';
}

class WorkOrderPhotoRepository {
  async upload({
    organizationId,
    divisionId,
    file,
    kind = 'photo',
  }: WorkOrderPhotoUploadParams): Promise<string> {
    const photoId = generateFirestoreId(FSCollections.EVENTS);
    const folder = kind === 'signature' ? 'signatures' : 'photos';
    const fileName = kind === 'signature' ? `${photoId}.png` : photoId;
    const path = `${FSCollections.ORGANIZATIONS}/${organizationId}/${FSCollections.DIVISIONS}/${divisionId}/${FSCollections.EVENTS}/${folder}/${fileName}`;

    await uploadBytes(ref(storage, path), file, { contentType: file.type });
    return path;
  }

  async remove(path: string): Promise<void> {
    await deleteObject(ref(storage, path));
  }
}

export default WorkOrderPhotoRepository;
